<script lang="ts">
import { showToast, TOAST } from '@mimir/web/eventBus';
import { VBtn, VIcon } from 'vuetify/lib';
import { defineComponent } from '@mimir/web/compat/vueCompat';

export default defineComponent({
  name: 'CopyButton',
  components: {
    VBtn,
    VIcon,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    btnText:{
      type: String,
      default: undefined,
    },
    snackBarText: {
      type: String,
      default: 'Copied to clipboard.',
    },
    icon: {
      type: String,
      default: 'content_copy',
    },
    tooltip: {
      type: String,
      default: undefined,
    },
    smallIcon: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: 'var(--v-strong-base)'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // Set to true to show an inline 'Copied!' text next to the clip board button. There may not be space for this,
    // so the default is to show a Toast info alert.
    useCopiedText: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showCopiedIcon: false,
    };
  },
  computed: {
    iconProxy() {
      return this.showCopiedIcon ? 'check' : this.icon;
    },
  },
  methods: {
    sendNotification() {
      if (this.disabled) return;

      if (this.useCopiedText) {
        this.showCopiedIcon = true;
        setTimeout(() => {
          this.showCopiedIcon = false;
        }, 2000);
      } else {
        showToast(this.snackBarText, TOAST.INFO);
      }
    }
  }
});
</script>

<template>
  <div>
    <VTooltip
      v-model="showCopiedIcon"
      left
      :open-on-hover="false"
    >
      <template #activator="{ on }">
        <div v-on="on" />
      </template>
      <span v-if="btnText">{{ btnText }}</span>
      <div
        v-else-if="showCopiedIcon"
        class="copy-txt caption"
      >Copied!</div>
    </VTooltip>
    <VBtn
      v-if="btnText"
      v-clipboard:copy="content ? content : 'No content found'"
      v-tooltip="{ disabled: !tooltip || disabled === true, text: tooltip }"
      class="text-none copy-btn"
      :disabled="disabled"
      aria-label="Copy"
      v-bind="$attrs"
      @click="sendNotification"
    >
      <VIcon
        :small="smallIcon"
        class="mr-1"
        :color="showCopiedIcon ? 'success' : iconColor"
      >
        {{ iconProxy }}
      </VIcon>
      <span v-if="btnText">{{ btnText }}</span>
    </VBtn>
    <VIcon
      v-else
      v-clipboard:copy="content ? content : 'No content found'"
      :small="smallIcon"
      class="mr-1"
      :color="disabled ? 'var(--v-dimmed-base)' : (showCopiedIcon ? 'success' : iconColor)"
      aria-label="Copy"
      @click="sendNotification"
    >
      {{ iconProxy }}
    </VIcon>
  </div>
</template>

<style lang="stylus">
  .copy-btn .copy-txt
    position: absolute
    left: 35px
    color: var(--v-strong-base)

</style>
